export const useImageFallback = (code: () => string | undefined) => {
  const hasError = ref(false);

  watch(code, (value) => {
    if (value) hasError.value = false;
  });

  return {
    hasError,
    onError: () => {
      hasError.value = true;
    },
  };
};
